import React from "react";
import PageTitle from "../Dashboard/PageTitle";
import "../Dashboard/main.css";
import LongtermTrackContainer from "./LongtermTrackContainer";

function Trackmain() {
  return (
    <main id="main" className="main">
      <PageTitle page={"Track"} />
      <LongtermTrackContainer />
    </main>
  );
}

export default Trackmain;
